<template>
    <div class="confirmation container-fluid mx-auto d-flex-center flex-column my-4 flex-fill body-container">
        <img src="../assets/img/logo.png" class="confirmation__logo mb-4" alt="" />

        <div class="bg-white py-4--5 px-4 shadow bg-opacity-75 rounded-5 d-flex-center flex-column">
            <i class="fa-solid fa-hourglass-end fa-5x my-2 text-primary"></i>
            <h2 class="w-100 my-4">Les inscriptions sont clôturées</h2>
        </div>
    </div>
</template>
<script>
import { countRegistration, nbMaxRegistrations } from "@/plugins/server";


export default {
    created() {
        countRegistration()
            .then(async (result) => {
                const data = result.data;
                if (data < nbMaxRegistrations) this.$router.push({ name: "home" });
            })
            .catch((error) => {
                const code = error.code;
                const message = error.message;
                const details = error.details;
                console.log(code, message, details);
                this.$data.hasError = true;
            });
    },
};
</script>
